import React from "react";
import { CopyButton } from "components/NodeDetail/BrevConnect/shared";

interface NetworkAddressCardProps {
  localIp?: string;
  privateDns?: string;
  unavailable?: boolean;
}

export const NetworkAddressCard: React.FC<NetworkAddressCardProps> = ({
  localIp,
  privateDns,
  unavailable = false,
}) => {
  const fallback = unavailable ? "Unavailable" : "Not assigned";
  const visibleLocalIp = unavailable ? undefined : localIp;
  const visiblePrivateDns = unavailable ? undefined : privateDns;

  return (
    <div className="mt-4 grid w-full gap-4 rounded-md bg-secondaryBg p-4 sm:grid-cols-2">
      <div>
        <p className="text-sm font-medium text-primary">Local IP</p>
        {visibleLocalIp ? (
          <div className="mt-1 flex min-w-0 items-center gap-1.5">
            <span
              className="truncate font-mono text-sm text-secondary"
              title={visibleLocalIp}
            >
              {visibleLocalIp}
            </span>
            <CopyButton value={visibleLocalIp} />
          </div>
        ) : (
          <p className="mt-1 text-sm text-secondary">{fallback}</p>
        )}
      </div>
      <div>
        <p className="text-sm font-medium text-primary">Private DNS</p>
        {visiblePrivateDns ? (
          <div className="mt-1 flex min-w-0 items-center gap-1.5">
            <span
              className="truncate font-mono text-sm text-secondary"
              title={visiblePrivateDns}
            >
              {visiblePrivateDns}
            </span>
            <CopyButton value={visiblePrivateDns} />
          </div>
        ) : (
          <p className="mt-1 text-sm text-secondary">{fallback}</p>
        )}
      </div>
    </div>
  );
};
